import { useSelector } from "react-redux";

export const LanguageMenuIcon = ({ className }) => {
  const lang_selected = useSelector((state) => state.site.lang_selected)
  return <img className={className} src={require('./assets/' + lang_selected + '.svg')} draggable={false} />;
};
